<div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
      <a class="" rel="studentDetails" href="#" title="payment Details"> </a>
    </div>
  </div>

  <div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header">
      <a class="" rel="studentDetails" href="#" title="Student Details">
        <img class="responsive" style="width: 100%; height: auto" src="assets/images/header-1.png"/>
      </a>
    </div>

    <section id="header" class="rounded" style="margin-top: 1%; background-color: white; text-align: center; text-emphasis-color: inherit;">
      <strong>DELHI SANSKRIT ACADEMY</strong>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-centered" style="align-items: center; text-decoration: underline">
            <strong> PAYMENT DETAILS </strong>
          </div>
        </div>
      </div>
    </section>

    <div class="card" style="margin-top: 1%">

      <div class="card-body">
        <div *ngIf="!myDIV">
          <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Name</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Enter Name" formControlName="name"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['name'].hasError('required')">Name is required.</mat-error>
                <mat-error *ngIf="form.controls['name'].hasError('pattern')">Invalid Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label> Address </mat-label>
                <input type="text" matInput maxlength="100" placeholder="Enter Address" formControlName="address"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['address'].hasError('required')">Address is required.</mat-error>
                <mat-error *ngIf="form.controls['address'].hasError('pattern')">Invalid Address</mat-error>
              </mat-form-field>
            </div>


            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label> Mobile No </mat-label>
                <input type="text" matInput max="10" min="10" (keydown)="maxValue($event)" placeholder="Enter Mobile No" formControlName="mobileNo"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('required')">Mobile No is required.</mat-error>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')">Invalid Mobile No</mat-error>
              </mat-form-field>
            </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> Email ID </mat-label>
                <input type="text" matInput maxlength="70" placeholder="Enter Email ID" formControlName="emailId" autocomplete="off" required />
              <mat-error *ngIf="form.controls['emailId'].hasError('pattern')">Invalid Email ID</mat-error> 
              <mat-error *ngIf="form.controls['emailId'].hasError('required')">Email ID is required</mat-error>
            </mat-form-field>
          </div>

                <div class="form-group">
                  <mat-form-field (focus)="hideError('standard')" class="mt5 wrapper"style="width:100%" >
                  <mat-label>Select Book Name</mat-label>
                  <mat-select matInput [(ngModel)]="selectedBooks" formControlName="bookName" autocomplete="off" (ngModelChange)="calculateTotalAmount()"  panelClass="testClass" multiple >
                    <mat-option value="VAIDIK- KHAND (SANSKRIT SUKTI SAMUCHAYA)">VAIDIK- KHAND (SANSKRIT SUKTI SAMUCHAYA)</mat-option>
                    <mat-option value="VEDANG- KHAND (SANSKRIT SUKTI SAMUCHAYA)">VEDANG- KHAND (SANSKRIT SUKTI SAMUCHAYA) </mat-option>
                    <mat-option value="BRAHMAN- KHAND (SANSKRIT SUKTI SAMUCHAYA)">BRAHMAN- KHAND (SANSKRIT SUKTI SAMUCHAYA)</mat-option>
                    <mat-option value="SANSKRIT NATYA- KHAND (SANSKRIT SUKTI SAMUCHAYA)">SANSKRIT NATYA- KHAND (SANSKRIT SUKTI SAMUCHAYA)</mat-option>
                    <mat-option value="ADHUNIK KAVYA-KHAND  (SANSKRIT SUKTI SAMUCHAYA) PART-20">ADHUNIK KAVYA-KHAND  (SANSKRIT SUKTI SAMUCHAYA) PART-20</mat-option>
                    <mat-option value="MUKTAK-KHAND  (SANSKRIT SUKTI SAMUCHAYA) PART-21">MUKTAK-KHAND  (SANSKRIT SUKTI SAMUCHAYA) PART-21</mat-option>
                    <mat-option value="VINSH SHATABDHI SANSKRIT KAVYA MRITTUM (PART-I)">VINSH SHATABDHI SANSKRIT KAVYA MRITTUM (PART-I)</mat-option>
                    <mat-option value="VINSH SHATABDHI SANSKRIT KAVYA MRITTUM (PART-II)">VINSH SHATABDHI SANSKRIT KAVYA MRITTUM (PART-II)</mat-option>
                    <mat-option value="DELHI-STAH-VINSH SHTABDHIYA SANSKRIT RACHNAKARA">DELHI-STAH-VINSH SHTABDHIYA SANSKRIT RACHNAKARA</mat-option>
                    <mat-option value="SWAATANTRYA-SWARN-SAURABHAM">SWAATANTRYA-SWARN-SAURABHAM</mat-option>
                    <mat-option value="SHANKAR GRANTHWALI (PART-1) (UPNISHADHBHASYAM)">SHANKAR GRANTHWALI (PART-1) (UPNISHADHBHASYAM)</mat-option>
                    <mat-option value="SHANKAR GRANTHWALI (PART-2) (BRAHMASUTRABHASYAM)">SHANKAR GRANTHWALI (PART-2) (BRAHMASUTRABHASYAM)</mat-option>
                    <mat-option value="SHANKAR GRANTHWALI (PART-3) (SHRIMADH-BHAGWATGEETA-BHASYAM)">SHANKAR GRANTHWALI (PART-3) (SHRIMADH-BHAGWATGEETA-BHASYAM)</mat-option>
                    <mat-option value="VED MANJARI (SHODH LEKH SANGRAH)">VED MANJARI (SHODH LEKH SANGRAH)</mat-option>
                    <mat-option value="VYAKARAN MANJARI  (SHODH LEKH SANGRAH)">VYAKARAN MANJARI  (SHODH LEKH SANGRAH)</mat-option>
                    <mat-option value="NIRUKTAH-SAMAARSH">NIRUKTAH-SAMAARSH</mat-option>
                    <mat-option value="RIGHVED SAHITA">RIGHVED SAHITA</mat-option>
                    <mat-option value="SAMVED SAHITA">SAMVED SAHITA</mat-option>
                    <mat-option value="ATHARVA-VED SAHITA">ATHARVA-VED SAHITA</mat-option>
                    <mat-option value="KATHA NIRJHARI">KATHA NIRJHARI</mat-option>
                    <mat-option value="SANSKRIT-KATHA-MANJARI">SANSKRIT-KATHA-MANJARI</mat-option>
                    <mat-option value="SAHITYA MANJARI (PART-I)">SAHITYA MANJARI (PART-I)</mat-option>
                    <mat-option value="SANSKRIT SANGEET SANDHYA (DVD)">SANSKRIT SANGEET SANDHYA (DVD)</mat-option>
                    <mat-option value="SANSKRIT GEET SANGEET (DVD)">SANSKRIT GEET SANGEET (DVD)</mat-option>
                    <mat-option value="SANSKRIT SHLOK SANGEET (DVD)">SANSKRIT SHLOK SANGEET (DVD)</mat-option>
                    <mat-option value="SANSKRIT KAVYALI (DVD)">SANSKRIT KAVYALI (DVD)</mat-option>
                    <mat-option value="SANKSRIT EKAL SHLOK SANGEET (DVD)">SANKSRIT EKAL SHLOK SANGEET (DVD)</mat-option>
                    <mat-option value="ISH DARSHANAM">ISH DARSHANAM</mat-option>
                    <mat-option value="VAIDIK VIMARSH">VAIDIK VIMARSH</mat-option>
                    <mat-option value="ISHA VASYOPANISHADH - A DISCIPIONARY STUDY">ISHA VASYOPANISHADH - A DISCIPIONARY STUDY</mat-option>
                    <mat-option value="SAMVED BHASHYAM">SAMVED BHASHYAM</mat-option>
                    <mat-option value="SANKSRIT-SUKTI-SURBHI">SANKSRIT-SUKTI-SURBHI</mat-option>
                    <mat-option value="DARSHAN PARI SHEELANAM">DARSHAN PARI SHEELANAM</mat-option>
                    <mat-option value="SANSKRIT SAHITYA PARI SHEELANAM">SANSKRIT SAHITYA PARI SHEELANAM</mat-option>
                    <mat-option value="DELHI SHLOK SAMASYA PURTI SANGRAH">DELHI SHLOK SAMASYA PURTI SANGRAH</mat-option>
                    <mat-option value="NATYA VALI">NATYA VALI</mat-option>
                    <mat-option value="VEDANT AND VIGYAN IN DRAVH GUN MIMANSHA">VEDANT AND VIGYAN IN DRAVH GUN MIMANSHA</mat-option>
                    <mat-option value="KATHA MANDAKANI">KATHA MANDAKANI</mat-option>
                    <mat-option value="SANSKRIT CHANDRIKA (MONTHLY  BAL PATRIKA PER COPY)">SANSKRIT CHANDRIKA (MONTHLY  BAL PATRIKA PER COPY)</mat-option>
                    <mat-option value="SANSKRIT CHANDRIKA (YEARLY BAL PATRIKA PER COPY)">SANSKRIT CHANDRIKA (YEARLY BAL PATRIKA PER COPY)</mat-option>
                    <mat-option value="SANSKRIT MANJARI (QUARTERLY SHODH PATRIKA PER COPY)">SANSKRIT MANJARI (QUARTERLY SHODH PATRIKA PER COPY)</mat-option>
                    <mat-option value="SANSKRIT MANJARI (YEARLY SHODH PATRIKA PER COPY)">SANSKRIT MANJARI (YEARLY SHODH PATRIKA PER COPY)</mat-option>
                    <mat-option value="RIGHVED KE DARSHNIK SUTRA">RIGHVED KE DARSHNIK SUTRA</mat-option>
                    <mat-option value="NATYA MRITTUM">NATYA MRITTUM</mat-option>
                    <mat-option value="KAVYA KALLOLINI">KAVYA KALLOLINI</mat-option>
                    <mat-option value="KAPISHA">KAPISHA</mat-option>
                    <mat-option value="KAVYA MALA">KAVYA MALA</mat-option>
                    <mat-option value="KAVYA KAIRVAM">KAVYA KAIRVAM</mat-option>
                    <mat-option value="SHANGERI SHATKAM">SHANGERI SHATKAM</mat-option>
                    <mat-option value="MRICH KATIK PARI SHEELNAM">MRICH KATIK PARI SHEELNAM</mat-option>
                    <mat-option value="ABHIDHAN RATNAMALA">ABHIDHAN RATNAMALA</mat-option>
                    <mat-option value="ESHAP-KATHA NIKUNJ">ESHAP-KATHA NIKUNJ</mat-option>
                    <mat-option value="VEDARTH NIRNAYE NIRUKTASYA MAHTVAM">VEDARTH NIRNAYE NIRUKTASYA MAHTVAM</mat-option>
                    <mat-option value="NAVYA NYAY VAAD GRANTHA">NAVYA NYAY VAAD GRANTHA</mat-option>
                    <mat-option value="SAMSYA PURTI SHATKAM">SAMSYA PURTI SHATKAM</mat-option>
                    <mat-option value="UNMISHITAM">UNMISHITAM</mat-option>
                    <mat-option value="CHINTANA LOKA">CHINTANA LOKA</mat-option>
                    <mat-option value="SANGHE SHAKTI SARVADHA">SANGHE SHAKTI SARVADHA</mat-option>
                    <mat-option value="HITOPADESH KATHA NATYAM">HITOPADESH KATHA NATYAM</mat-option>
                    <mat-option value="VISHWE ETIYASASYA TITHIKRAM">VISHWE ETIYASASYA TITHIKRAM</mat-option>
                    <mat-option value="SRAWANSHYA PRATAM DIWASE">SRAWANSHYA PRATAM DIWASE</mat-option>
                    <mat-option value="AASHIRWAD">AASHIRWAD</mat-option>
                    <mat-option value="AASHA">AASHA</mat-option>
                    <mat-option value="ABHINAV STATVA MUKTAWALI">ABHINAV STATVA MUKTAWALI</mat-option>
                    <mat-option value="SANSKRIT SAHITYA MANJUSHA">SANSKRIT SAHITYA MANJUSHA</mat-option>
                    <mat-option value="NATYA MRITAM">NATYA MRITAM</mat-option>
                    <mat-option value="KATHA MRITAM">KATHA MRITAM</mat-option>
                    <mat-option value="CONTRIBUTION OF WEST BENGAL IN MODERN SANSKRIT LITERATURE">CONTRIBUTION OF WEST BENGAL IN MODERN SANSKRIT LITERATURE</mat-option>
                    <mat-option value="ADHARAM MADHURAM (KATHA SANGRAH)">ADHARAM MADHURAM (KATHA SANGRAH)</mat-option>
                    <mat-option value="KALIDASHYAM (SHODH LEKHAN SANKLAN)">KALIDASHYAM (SHODH LEKHAN SANKLAN)</mat-option>
                                                              
                  </mat-select>
                  <mat-error *ngIf="form.controls['bookName'].hasError('required')">Book Name is required.</mat-error>
                </mat-form-field>
                </div>

                 <div class="form-group form-obj" style="width:100%">
                  <mat-form-field style="width:100%" >
                    <mat-label>Total Book Fee Amount</mat-label>
                    <input type="number"  matInput maxlength="50" placeholder="Total Book Fee Amount" formControlName="amount"  [readonly]="true"/>
                     </mat-form-field>
                      <!-- {{totalAmount}} -->
                </div>

                
                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label>Miscellenous Payment Amount</mat-label>
                    <input type="text" maxlength="50" matInput placeholder="Enter Miscellenous Payment Amount" formControlName="miscellenousAmount" autocomplete="off" />
                    <mat-error *ngIf="form.controls['miscellenousAmount'].hasError('required')">Miscellenous Payment Amount is required.</mat-error>
                    <mat-error *ngIf="form.controls['miscellenousAmount'].hasError('pattern')">Invalid Miscellenous Payment Amount</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label> Miscellenous Payment Remarks </mat-label>
                    <input type="text" matInput maxlength="100" placeholder="Enter  Miscellenous Payment Remarks" formControlName="miscellenousRemarks"  autocomplete="off" />
                    <mat-error *ngIf="form.controls['miscellenousRemarks'].hasError('required')"> Miscellenous Payment Remarks is required.</mat-error>
                    <mat-error *ngIf="form.controls['miscellenousRemarks'].hasError('pattern')">Invalid  Miscellenous Payment Remarks</mat-error>
                  </mat-form-field>
                </div>


                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label> Remarks 1 </mat-label>
                    <input type="text" matInput maxlength="100" placeholder="Enter Remarks 1" formControlName="remarks"  autocomplete="off" />
                    <mat-error *ngIf="form.controls['remarks'].hasError('required')">Remarks 1 is required.</mat-error>
                    <mat-error *ngIf="form.controls['remarks'].hasError('pattern')">Invalid Remarks 1</mat-error>
                  </mat-form-field>
                </div>

                <div class="form-group">
                    <p>Remarks 2</p>
                  <p style="color: red;"><strong> Note : PLEASE BE ENSURE ABOUT THE AVAILABILITY OF BOOK FROM PUBLICATION BRANCH (DELHI SANSKRIT ACADEMY) BEFORE PAYMENT.</strong></p>
              </div>
              <!-- <div class="col-md-12" style="display: inline-block;"> -->
             

                <div class="form-group form-obj" style="width:100%">
                  <mat-form-field style="width:100%">
                    <mat-label>Final Amount</mat-label>
                    <input type="number" matInput placeholder="Final Amount" formControlName="finalAmount" value ={{getTotal()}} autocomplete="of" [readonly]="true" required style="font-weight: bold;color:black "/>
                  </mat-form-field>
            </div>

            <div class="form-group">
              <label> Captcha <span>*</span></label>
              <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                 class="captchaFeild"  formControlName="captcha" autocomplete="off"
                minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
                <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                  <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                  <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is Invalid </div>
                  <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                </div>
             </div>
             <div id="capt">
                 <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                 <span style="float: right; cursor: pointer;">
                         <i class="material-icons" (click)="Cap()">refresh</i>
                 </span>
            </div> 
          
                   <!-- <div class="form-group"> -->
                          <!-- <button [disabled]="loading" (click)="onSubmit()" style="margin-right:50px;" class="btn btn-primary" >
                              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                              Pay Now
                          </button> -->
                          <div class="form-group" style="display: flex; margin-top: 30px; justify-content: space-evenly;">
                            <button #submitButton style="width: 129px;" class="btn btn-primary">
                              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                              PAY NOW
                            </button>
                          </div>
                          <!-- <button (click)="redirectHome()" class="btn btn-primary" >
                            BACK TO HOME
                          </button> -->
                  <!-- </div> -->
              <!-- </div> -->

          </form>

        </div>
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
